<div class="modal-header">
  <h4 class="modal-title">{{ title | translate }}</h4>
  <button type="button" class="close" (click)="closeModal()">{{ 'exports.modalHeader.closeButton' | translate }}</button>
</div>
<div class="modal-body">
  <form [formGroup]="exportForm" #filmForm="ngForm" (ngSubmit)="export()">
    <div class="form-group">
      <label for="selectedCinema">{{ 'exports.form.selectCinema' | translate }}</label>
      <select id="selectedCinema" formControlName="selectedCinema" class="form-control">
        <option value="all">{{ 'exports.form.selectCinema' | translate }}</option>
        <option *ngFor="let cinema of cinemas" [value]="cinema.id_cinema">
          {{ cinema.liv_ville }} - {{ cinema.nom_cinema }}
        </option>
      </select>
    </div>

    <div class="form-group">
      <label for="weeksBefore">{{ 'exports.form.weeksBefore' | translate }}</label>
      <input type="number" id="weeksBefore" formControlName="weeksBefore" class="form-control" />
    </div>

    <div class="form-group">
      <label>{{ 'exports.form.weeksAfter' | translate }}</label>
      <input type="number" id="weeksAfter" formControlName="weeksAfter" class="form-control" />
    </div>

    <div class="form-group">
      <label>{{ 'exports.form.typeExport' | translate }}</label><br>
      <input type="radio" id="etat_semaine" formControlName="type_export" value="etat_semaine" />
      <label for="etat_semaine">{{ 'exports.form.exportOptions.etatSemaine' | translate }}</label><br>

      <input type="radio" id="etat_semaine_advanced" formControlName="type_export" value="etat_semaine_advanced" />
      <label for="etat_semaine_advanced">{{ 'exports.form.exportOptions.etatSemaineAdvanced' | translate }}</label><br>

      <input type="radio" id="etat_detaille" formControlName="type_export" value="etat_detaille" />
      <label for="etat_detaille">{{ 'exports.form.exportOptions.etatDetaille' | translate }}</label><br>
    </div>

    <div class="form-group">
      <label>{{ 'exports.form.formatExport' | translate }}</label>
      <div class="form-check">
        <input class="form-check-input" type="radio" id="formatPdf" value="pdf" formControlName="format" />
        <label for="formatPdf">{{ 'exports.form.formatPdf' | translate }}</label>
      </div>
      <div class="form-check">
        <input class="form-check-input" type="radio" id="formatExcel" value="excel" formControlName="format" />
        <label for="formatExcel">{{ 'exports.form.formatExcel' | translate }}</label>
      </div>
      <div *ngIf="showEmailOptions" class="form-check">
        <input class="form-check-input" type="radio" id="formatEmail" value="email" formControlName="format" />
        <label for="formatEmail">{{ 'exports.form.formatEmail' | translate }}</label>
      </div>
    </div>

    <div *ngIf="exportForm.get('format')?.value === 'email'" class="form-group">
      <div class="container-fluid">
        <div>
          <label for="emailAdmin">{{ 'exports.form.emailAdmin' | translate }}</label>
          <div class="email-checkbox-row">
            <input class="form-check-input" type="checkbox" id="sendAdminEmails" formControlName="sendAdminEmails" />
            <input type="email" id="emailAdmin" formControlName="emailAdmin" class="form-control" />
          </div>
        </div>
        <div>
          <label for="emailTech">{{ 'exports.form.emailTech' | translate }}</label>
          <div class="email-checkbox-row">
            <input class="form-check-input" type="checkbox" id="sendTechEmails" formControlName="sendTechEmails" />
            <input type="email" id="emailTech" formControlName="emailTech" class="form-control" />
          </div>
        </div>
      </div>
    </div>
  </form>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-primary" (click)="filmForm.ngSubmit.emit()">{{ 'exports.form.submitButton' | translate }}</button>
</div>
